const LoanApplicationTableAsignTo = ["mohit@credfin.money","mohit@abhicash.in","mohit@micromoney.in"]
const changeLeadStatusNotcheck = ["accounts@credfin.money","accounts@micromoney.in","accounts@abhicash.in","Ujjwal.gupta@micromoney.in"]
// const CRIFRegenrateButtonCheck = ["SuperUser","vansh@credfin.money","karan@micromoney.in","vicky.rawani@abhicash.in","vikas.kumar@abhicash.in","Mayank@credfin.money","tanishagupta@micromoney.in"]
const CRIFRegenrateButtonCheck = ["SuperUser","vansh@credfin.money","karan@micromoney.in","vicky.rawani@abhicash.in","vikas.kumar@abhicash.in","tanishagupta@micromoney.in","vaishali.bisht@abhicash.in","Kaushal.nayak@abhicash.com","ajay.negi@cnmp.in","abhishek.srivastava@cnmp.in","shivam@cnmp.in","siddhart@abhicash.in","Mayank@credfin.money","sourabh.singh@cnmp.in","lalit@cnmp.in","Anju.prajapati@cnmp.in","vicky.TL@abhicash.in","anju.prajapati@cnmp.in","nisha.gayal@abhicash.in","tanima.ghosh@abhicash.in"]
const NachcheckboxButtoncheck = ["SuperUser","siddhart@abhicash.in"]
const GenerateReportcheck = ["shubham.goyal@credfin.money","harshit@credfin.money","mohit.bansal@credfin.money","fahad@credfin.money","arsad@abhicash.in","nisha.gayal@abhicash.in","tanima.ghosh@abhicash.in","vicky.rawani@abhicash.in","shashank.saxena@abhicash.in","mohit.bansal@abhicash.in","karan@micromoney.in","mohit.bansal@micromoney.in","riya@credfin.money","vikas.kumar@abhicash.in","sashi.prasad@cnmp.in","DEBASHISH.MONDAL@CNMP.IN","Sangita.Rajbanshi@abhicash.in","JASMIN.KHATUN@CNMP.IN","parul@creditjar.in","pooja@cashbridge.in","Shreyansh@cashbridge.in","viraj.sangani@creditjar.in","neeraj.bhardwaj@cashbridge.in"]
const AADHARRegenrateCheck = ["siddhart@abhicash.in"]
const CustomLeadManagementAllDataListShow = ["siddhart@abhicash.in","tanima.ghosh@abhicash.in","nisha.gayal@abhicash.in"]

const EmailcheckFn = (email , checkArray)=>{
    if(checkArray.includes(email)){
        return true
    }
    return false
}
const EmailNotcheckFn = (email , checkArray)=>{
    if(!checkArray.includes(email)){
        return true
    }
    return false
}


export {
    EmailcheckFn,EmailNotcheckFn,
    LoanApplicationTableAsignTo,
    changeLeadStatusNotcheck,
    CRIFRegenrateButtonCheck,
    GenerateReportcheck,AADHARRegenrateCheck, CustomLeadManagementAllDataListShow, NachcheckboxButtoncheck

}